module.exports = __webpack_public_path__ + "img/redemptor.acce4058.png";